// Configuração do EmailJS
// Para usar este serviço, você precisa:
// 1. Criar uma conta em https://emailjs.com
// 2. Configurar um serviço de email (Gmail, Outlook, etc.)
// 3. Criar um template de email
// 4. Substituir os valores abaixo pelos seus

export const EMAILJS_CONFIG = {
  // Substitua pelos seus valores do EmailJS
  SERVICE_ID: 'service_impetus', // Seu Service ID
  TEMPLATE_ID: 'template_orcamento', // Seu Template ID
  PUBLIC_KEY: 'YOUR_PUBLIC_KEY', // Sua Public Key
  
  // Email de destino
  TO_EMAIL: 'comercial@impetusgastronomia.com.br'
};

// Template de email sugerido para o EmailJS:
/*
Assunto: Novo Orçamento - {{from_name}}

Olá,

Você recebeu uma nova solicitação de orçamento através do site:

Nome: {{from_name}}
Email: {{from_email}}
Telefone: {{phone}}
Tipo de Evento: {{event_type}}
Número de Convidados: {{guests}}
Data do Evento: {{event_date}}

Mensagem:
{{message}}

---
Enviado através do site Impetus Gastronomia
*/
